import type { Resource } from "@medplum/fhirtypes";
import { TRPCClientError, type TRPCLink } from "@trpc/client";
import { observable } from "@trpc/server/observable";
import type { AppRouter } from "./routers";
export interface SyncRecords {
  written: Resource[];
  deleted: Resource[];
}
let applySync: (sync: SyncRecords) => void = () => {};
export function setSyncReceiver(receiver: typeof applySync) {
  applySync = receiver;
  return () => {
    if (applySync === receiver) applySync = () => {};
  };
}
export function syncLink(apply: (sync: SyncRecords) => void = (sync) => applySync(sync)): TRPCLink<AppRouter> {
  return () =>
    ({ op, next }) =>
      observable((observer) =>
        next(op).subscribe({
          next(value) {
            if (op.type !== "mutation" || !("data" in value.result)) {
              observer.next(value);
              return;
            }
            try {
              const envelope = value.result.data as { result: unknown; sync: SyncRecords };
              if (envelope?.sync) {
                apply(envelope.sync);
                observer.next({ ...value, result: { type: "data", data: envelope.result } });
              } else observer.next(value);
            } catch (error) {
              observer.error(TRPCClientError.from(error as Error));
            }
          },
          error: (error) => observer.error(error),
          complete: () => observer.complete(),
        }),
      );
}
